const useGetModifierGroups = menuItem => menuItem?.modifier_groups ?? [];

export default useGetModifierGroups;
